import styled from "styled-components";

export const OverviewContainer = styled.div`
  max-width: 375px;
  padding: 64px 24px 32px 24px;
  gap: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  text-align: center;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    max-width: 562px;
    gap: 0px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    max-width: 1156px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    text-align: center;
  }
`;

export const OverviewTitle = styled.span`
  text-align: center;
  display: inline-flex;
  font-family: ThemeFontBold;
  font-weight: 700;
  color: ${({ theme }) => theme.customTheme.palette.black.black1};
  font-size: ${({ theme }) => theme.customTheme.pxToRem(20)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(24)};
  order: 1;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    order: 2;
    font-size: ${({ theme }) => theme.customTheme.pxToRem(56)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(68)};
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    display: none;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  order: 2;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    width: 514px;
    order: 1;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    width: 587px;
  }

  img {
    max-width: 100%;
  }
`;

export const OverviewLogosContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  order: 3;

  & .slick-slider.slick-initialized {
    width: 100%;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    margin: 52px 0px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    display: none;
  }
`;

export const LogoItem = styled.div`
  width: 85px;
  filter: brightness(0) contrast(20%);
`;

export const LoginButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: fit-content;
  border-radius: 28px;
  font-weight: 700;
  text-decoration: none;
  text-align: center;
  order: 4;
  padding: 14px 24px;
  color: ${({ theme }) => theme.customTheme.palette.white.standard};
  background-color: ${({ theme }) => theme.customTheme.palette.red.standard};
  font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(22)};
  font-family: ThemeFontRegular;
  filter: brightness(100%);
  transition: filter 200ms ease;

  &:hover {
    filter: brightness(150%);
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    width: 327px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    display: none;
  }
`;

export const DesktopContentLayout = styled.div`
  display: none;
  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    padding: 64px 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    text-align: center;
    max-width: 562px;
    gap: 0px;
  }
`;

export const OverviewTitleDesktop = styled.span`
  text-align: center;
  display: inline-flex;
  font-family: ThemeFontBold;
  font-weight: 700;
  color: ${({ theme }) => theme.customTheme.palette.black.black1};

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    order: 2;
    font-size: ${({ theme }) => theme.customTheme.pxToRem(56)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(68)};
  }
`;

export const OverviewLogosContainerDesktop = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
  order: 3;

  & .slick-slider.slick-initialized {
    width: 100%;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    margin: 52px 0px;
  }
`;

export const LoginButtonDesktop = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: fit-content;
  border-radius: 28px;
  font-weight: 700;
  text-decoration: none;
  text-align: center;
  order: 4;
  padding: 14px 24px;
  color: ${({ theme }) => theme.customTheme.palette.white.standard};
  background-color: ${({ theme }) => theme.customTheme.palette.red.standard};
  font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(22)};
  font-family: ThemeFontRegular;
  filter: brightness(100%);
  transition: filter 200ms ease;

  &:hover {
    filter: brightness(150%);
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    width: 327px;
  }
`;
